import { ThemeProvider } from "@mui/material/styles";
import { Alert, Box } from "@mui/material";
import { theme } from "./hoc/Theme";
import { usePageTitle } from "./hoc/Hooks";
import Header from "./Header";
import { APP_NAME } from "config";
import SideMenu from "./SideMenu";
import { useLayout } from "features/store";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { OBSOLETE_PAGE_DISCLAIMER } from "constants/index";

type LayoutProps = {
  title?: string;
  content?: string;
  // Set on the pages grouped under the side menu's "Obsolete" group:
  // renders a non-dismissible warning above the page content.
  obsolete?: boolean;
};

const Layout = ({
  title,
  content,
  obsolete,
  children,
}: React.PropsWithChildren<LayoutProps>) => {
  usePageTitle(`${APP_NAME} | ` + (title || ""));

  const { drawerWidth } = useLayout();

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box width={"100%"}>
          <Box
            marginLeft={`${drawerWidth + 8}px`}
            marginTop={"75px"}
            marginRight={1}
            flexGrow={1}
          >
            {obsolete && (
              <Alert severity="warning" sx={{ mb: 1 }}>
                {OBSOLETE_PAGE_DISCLAIMER}
              </Alert>
            )}
            {children}
          </Box>
        </Box>
        <SideMenu />
        <Header title={title} />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default Layout;
